import { render } from "./CotationSection.vue?vue&type=template&id=22397294&scoped=true"
import script from "./CotationSection.vue?vue&type=script&lang=js"
export * from "./CotationSection.vue?vue&type=script&lang=js"

import "./CotationSection.vue?vue&type=style&index=0&id=22397294&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22397294"]])

export default __exports__